import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Home from './pages/Home';
import Contact from './pages/Contact';
import Products from './pages/Products';

export default function App() {
  return (
    <Router>
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/contact" element={<Contact />} />
        <Route path="/products" element={<Products />} />
        <Route path="/products/:category" element={<Products />} />
        {/* Placeholder routes for future pages */}
        <Route path="/shop" element={<div>Shop Page - Coming Soon</div>} />
        <Route path="/account" element={<div>Account Page - Coming Soon</div>} />
      </Routes>
    </Router>
  );
}